import {
  WHERE,
  WHEN,
  CONTACT,
  QUESTIONS,
  CONFIRMATION,
  VERIFICATION,
  selectScheduleTourStep,
  PREFERRED_AGENT,
  setScheduleTourStepAdvanceOneStep,
  setScheduleTourDataToInitialState
} from '../../../../../../../store/slices/scheduleTour'
import { useDispatch, useSelector } from 'react-redux'
import { Where } from './Where'
import { When } from './When'
import { Contact } from './Contact'
import { Questions } from './Questions'
import { Confirmation } from './Confirmation'
import { Listing } from '../../../../../../../api/gqlaxy/gql/generated/graphql'
import { AgentPreference } from './AgentPreference/AgentPreference'
import { VerificationFlow } from './Verification/VerificationFlow'
import { useToast } from '@homebotapp/hb-react-component-catalog'
import { useVerificationFlowEnabled } from '../../../../../../../hooks'
import { defineMessages, useIntl } from 'react-intl'

const MSG = defineMessages({
  complete: {
    id: 'scheduleTourModalSteps.complete',
    defaultMessage: 'Tour scheduled'
  }
})

export interface ScheduleTourModalStepsProps {
  listing: Listing
}

const ScheduleTourModalSteps = ({ listing }: ScheduleTourModalStepsProps) => {
  const intl = useIntl()
  const currentStep = useSelector(selectScheduleTourStep)
  const dispatch = useDispatch()
  const isVerificationFlowEnabled = useVerificationFlowEnabled()
  const toast = useToast()

  return (
    <>
      {currentStep === WHERE && <Where />}
      {currentStep === WHEN && <When />}
      {currentStep === CONTACT && <Contact />}
      {currentStep === PREFERRED_AGENT && <AgentPreference listing={listing} />}
      {currentStep === VERIFICATION && (
        <VerificationFlow
          listing={listing}
          onSkip={() => {
            dispatch(setScheduleTourDataToInitialState())
          }}
          onComplete={() => {
            // If the verification flow is enabled, we are handling
            // messaging and pre-qual through it, so when we are done with that
            // flow, we can just complete the schedule tour flow.
            //
            // The other interesting case here is that if
            // we choose to message the listing agent, we won't
            // need to go through the verification flow,
            // so we should essentially skip it and just use
            // the old way of handling messaging/pre-qual.
            if (isVerificationFlowEnabled) {
              dispatch(setScheduleTourDataToInitialState())
              toast({
                title: intl.formatMessage(MSG.complete),
                status: 'success'
              })
            } else {
              // Otherwise, we are just advancing to the next step and
              // handling messaging/pre-qual through the old way
              dispatch(setScheduleTourStepAdvanceOneStep())
            }
          }}
        />
      )}
      {currentStep === QUESTIONS && <Questions listing={listing} />}
      {currentStep === CONFIRMATION && <Confirmation listing={listing} />}
    </>
  )
}

export default ScheduleTourModalSteps
